import React from 'react';
import i18next from 'i18next';
import { bool } from 'prop-types';
import { useSelector } from 'react-redux';

import useCheckStoreOpen from '~hooks/useCheckStoreOpen';
import { DISPATCH_METHODS } from '~constants/address';
import { DISPATCH_METHOD_TARGET } from '~redux/SearchStore/constants';
import { ICONS } from '~constants/icons';
import Text from '~components/Text';

import styles from '../../styles.module.scss';

const InfoBox = ({ isScheduled }) => {
  const currentSubsidiary = useSelector((state) => state.searchStore.currentSubsidiary);
  const dispatchType = useSelector((state) => state.searchStore[DISPATCH_METHOD_TARGET]);
  const { onlyScheduledOrders } = useCheckStoreOpen();
  const message =
    dispatchType === DISPATCH_METHODS.PICKUP
      ? i18next.t('StoreInfo:unavailableForPickup')
      : i18next.t('StoreInfo:unavailableForDelivery');
  return (
    <>
      <div className={`m-bottom-4 ${styles.storeInfo}`}>
        <span className={`material-icons-outlined m-right-2 ${styles.iconLink}`}>
          {dispatchType === DISPATCH_METHODS.DELIVERY ? ICONS.DELIVERY : ICONS.PICKUP}
        </span>
        <Text className={styles.address}>
          {dispatchType === DISPATCH_METHODS.DELIVERY
            ? i18next.t('Delivery:from', {
                value: currentSubsidiary.name
              })
            : i18next.t('Delivery:fromPickUp', {
                value: `${currentSubsidiary.name}. ${currentSubsidiary.textAddress}. ${currentSubsidiary.commune}.`
              })}
        </Text>
      </div>
      {message && onlyScheduledOrders && !isScheduled && (
        <div className={`m-bottom-4 ${styles.storeInfo}`}>
          <Text className={styles.address}>{message}</Text>
        </div>
      )}
    </>
  );
};

InfoBox.propTypes = {
  isScheduled: bool
};

export default InfoBox;
